// MYG-151497: QR (OAuth device authorization grant) sign-in for the Tesla Semi IVI.

// The Tesla in-vehicle browser appends `Tesla/<firmware>` to its user agent, where the firmware is a calver
// such as 2026.32.3.1 (MYG-147702, Tesla's reply of 2026-09-10). The full string has not been captured
// from a real Semi yet; this only relies on that documented token.
const TESLA_USER_AGENT_PATTERN = /\bTesla\/\d{4}\.\d+/;
// The "Tesla" Keycloak client. It exists only on the login-test realm (the device grant is enabled on it and refused on
// the regular Drive client), so the id is meaningless anywhere else; see QR_DEVICE_GRANT_ISSUERS. It is fixed on
// purpose: the address of the page must not be able to pick the client that signs a driver in.
export const QR_CLIENT_ID = "457484977a6542c28d5f6fa13bd3dd9f";
// The realms the Tesla client above belongs to. The QR option is offered only when the server's own IAM settings point
// at one of them: on any other realm (production has its own) Keycloak would refuse the client and the option would
// fail every time. Remove this, and the constant above, once the server tells Drive which client to use.
const QR_DEVICE_GRANT_ISSUERS = ["https://login-test.geotab.com/realms/013ade617a0145b1bfb4e3b537733037"];

/** The QR sign-in is considered only in the Tesla in-vehicle browser. Nobody else sees it. */
export function isQrLoginEnabled(userAgent: string): boolean {
    return TESLA_USER_AGENT_PATTERN.test(userAgent);
}

/** True when the server's realm is one the hardcoded Tesla client belongs to. */
export function isQrLoginIssuerSupported(issuer: string): boolean {
    const normalized = issuer.replace(/\/+$/, "").toLowerCase();
    return QR_DEVICE_GRANT_ISSUERS.some(supported => supported === normalized);
}

/** The server does not allow Drive IAM sign-in for this user (a Drive-IAM switch is on, or the user signs in with SAML). */
export class QrLoginNotAllowedError extends Error {
    constructor() {
        super("Drive IAM sign-in is not allowed for this user.");
        // Extending Error under an ES5 target breaks instanceof unless the prototype is restored.
        Object.setPrototypeOf(this, QrLoginNotAllowedError.prototype);
        this.name = "QrLoginNotAllowedError";
    }
}
